// components/DropdownSelect.tsx
import React from "react";
import { DropdownProps } from "./types";
import { useDropdown } from "./useDropdown";
import { DropdownButton } from "./DropdownButton";
import { DropdownSearch } from "./DropdownSearch";
import { DropdownOptions } from "./DropdownOptions";

export const DropdownSelect: React.FC<DropdownProps> = (props) => {
  const {
    options,
    placeholder = "Select...",
    searchable = false,
    disabled = false,
    maxHeight = "300px",
    className = "",
  } = props;

  const {
    isOpen,
    setIsOpen,
    searchTerm,
    setSearchTerm,
    highlightedIndex,
    setHighlightedIndex,
    filteredOptions,
    isSelected,
    handleOptionSelect,
    getSelectedLabels,
    dropdownRef,
    searchInputRef,
    multiSelect,
  } = useDropdown(props);

  const toggleDropdown = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
      setSearchTerm("");
    }
  };

  return (
    <div ref={dropdownRef} className={`relative w-full ${className}`}>
      <DropdownButton
        isOpen={isOpen}
        disabled={disabled}
        selectedLabels={getSelectedLabels()}
        placeholder={placeholder}
        multiSelect={multiSelect}
        value={props.value}
        options={options}
        onClick={toggleDropdown}
      />

      {isOpen && (
        <div className="absolute z-50 w-full mt-1 bg-white border border-[rgb(232,232,232)] rounded-md shadow-lg">
          {searchable && (
            <DropdownSearch
              ref={searchInputRef}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
          )}

          <DropdownOptions
            options={filteredOptions}
            isSelected={isSelected}
            highlightedIndex={highlightedIndex}
            onOptionSelect={handleOptionSelect}
            onOptionHover={setHighlightedIndex}
            multiSelect={multiSelect}
            maxHeight={maxHeight}
          />
        </div>
      )}
    </div>
  );
};
// export const DropdownSelect: React.FC<DropdownProps> = ({
//   options,
//   value,
//   onChange,
//   placeholder = "Select an option",
//   searchable = false,
//   multiSelect = false,
//   disabled = false,
//   maxHeight = "300px",
//   className = "",
// }) => {
//   const {
//     isOpen,
//     setIsOpen,
//     searchTerm,
//     setSearchTerm,
//     highlightedIndex,
//     setHighlightedIndex,
//     filteredOptions,
//     isSelected,
//     handleOptionSelect,
//     getSelectedLabels,
//     dropdownRef,
//     searchInputRef,
//   } = useDropdown({
//     options,
//     value,
//     onChange,
//     searchable,
//     multiSelect,
//   });

//   const toggleDropdown = () => {
//     if (!disabled) {
//       setIsOpen(!isOpen);
//       setSearchTerm("");
//     }
//   };

//   return (
//     <div ref={dropdownRef} className={`relative w-full ${className}`}>
//       <DropdownButton
//         isOpen={isOpen}
//         disabled={disabled}
//         selectedLabels={getSelectedLabels()}
//         placeholder={placeholder}
//         multiSelect={multiSelect}
//         value={value}
//         options={options}
//         onClick={toggleDropdown}
//       />

//       {isOpen && (
//         <div className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg">
//           {searchable && (
//             <DropdownSearch
//               ref={searchInputRef}
//               searchTerm={searchTerm}
//               onSearchChange={setSearchTerm}
//             />
//           )}

//           <DropdownOptions
//             options={filteredOptions}
//             isSelected={isSelected}
//             highlightedIndex={highlightedIndex}
//             onOptionSelect={handleOptionSelect}
//             onOptionHover={setHighlightedIndex}
//             multiSelect={multiSelect}
//             maxHeight={maxHeight}
//           />
//         </div>
//       )}
//     </div>
//   );
// };
